import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=9b1f11a8&scoped=true&"
import script from "./Ai.vue?vue&type=script&lang=js&"
export * from "./Ai.vue?vue&type=script&lang=js&"
import style0 from "./Ai.vue?vue&type=style&index=0&id=9b1f11a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1f11a8",
  null
  
)

export default component.exports